import script from "./MBreadcrumbItemV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./MBreadcrumbItemV2.vue?vue&type=script&setup=true&lang=ts"

import "./MBreadcrumbItemV2.vue?vue&type=style&index=0&id=b0fd3c2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0fd3c2e"]])

export default __exports__